import APIClient from "../../../common/APIClient";
import {
  toggleShowAlert,
  displayError,
  SUCCESS_ALERT,
  MAX_ITEMS_IN_PAGE,
  setIsSaving,
} from "../commonActions";
import qs from "qs";

const FETCH_POSTS = "FETCH_POSTS";
const SET_POST_FIELD_CHANGE = "SET_POST_FIELD_CHANGE";
const SET_POST = "SET_POST";
const RESET_POST = "RESET_POST";
const POST_FILTER = "POST_FILTER";
const CLEAR_POSTS = "CLEAR_POSTS";

export const SET_POSTS_PAGINATION = "SET_POSTS_PAGINATION";
export const RESET_POSTS_PAGINATION = "RESET_POSTS_PAGINATION";
export const ENABLE_POST_ACTION = "ENABLE_POST_ACTION";
export const DISABLE_POST_ACTION = "DISABLE_POST_ACTION";
export const DISABLED_USER = 1;
export const ACTIVE_USER = 0;

export const EDITOR_PREFIX = `<p></p>\n`;

//TODO: fetch post_status definitions from the api and assign as constants. probably save them in state
export const DRAFT = 1;
export const PUBLISHED = 2;
//TODO: fetch post_type definitions from the api and assign as constants. probably save them in state
export const TERMS = 1;
export const PRIVACY_POLICY = 2;
export const NEWS = 3;
export const ANNOUNCEMENT = 4;
export const FAQS = 5;

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
};

export const fetchPosts = (
  filters = null,
  page = 1,
  limit = MAX_ITEMS_IN_PAGE
) => {
  if (!filters) {
    filters = {};
  }

  return (dispatch, getState) => {
    page = getState().posts.currentPage;

    client()
      .get("posts/list", {
        params: {
          filters,
          page,
          limit,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let posts = result.data;
          let pagination = result.pagination;
          if (!posts.length) {
            posts = null;
          }

          let max =
            pagination?.total_items < MAX_ITEMS_IN_PAGE
              ? pagination?.total_items
              : getState().posts.max;

          dispatch({
            type: FETCH_POSTS,
            posts,
            currentPage: getState().posts.currentPage,
            totalItems: pagination?.total_items,
            totalPages: pagination?.total_pages,
            max,
          });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const handleInputChange = (e, definedValue = null) => {
  return (dispatch) => {
    let value = {};
    if (!e && definedValue) {
      value = definedValue;
    } else {
      const id = e.target.id;

      value = {
        [id]: e.target.value,
      };
    }

    dispatch({ type: SET_POST_FIELD_CHANGE, value });
  };
};

export const getPost = (id) => {
  return (dispatch) => {
    client()
      .get("posts/get", {
        params: {
          id,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let post = result.data;
          dispatch({ type: SET_POST, post });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const getTerms = () => {
  return getPostByType(TERMS);
};

export const getPrivacyPolicy = () => {
  return getPostByType(PRIVACY_POLICY);
};

export const getFAQs = () => {
  return getPostByType(FAQS);
};

const getPostByType = (postType) => {
  return (dispatch, getState) => {
    client()
      .get("posts/list", {
        params: {
          filters: {
            post_type: postType,
          },
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          const posts = result.data;
          if (posts.length) {
            const post = posts.shift();
            dispatch({ type: SET_POST, post });
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const upsertPost = (callback = null) => {
  return (dispatch, getState) => {
    dispatch(setIsSaving(true));

    const clientObj = getState().posts.post;
    clientObj.app_id = clientObj?.app?.id || 1;
    clientObj.title = clientObj.title || "Draft " + Date().now;
    clientObj.description =
      clientObj.description.replace(EDITOR_PREFIX, "") || "";
    clientObj.post_type = !isNaN(clientObj?.post_type)
      ? clientObj?.post_type
      : clientObj?.post_type?.id || ANNOUNCEMENT;
    clientObj.status = clientObj?.status?.id || DRAFT;
    delete clientObj.updated_at;
    delete clientObj.updated_by;
    delete clientObj.created_at;
    delete clientObj.created_by;

    //prevent saving empty posts
    if (!clientObj.description || clientObj.description.length <= 10) {
      dispatch(setIsSaving(false));
      return false;
    }

    let endpoint = "posts/create";
    let message = "Post has been successfully created.";

    if (clientObj.id) {
      endpoint = "posts/update";
      message = "Post has been successfully updated.";
    }

    client()
      .post(endpoint, clientObj)
      .then((json) => {
        const result = json.data;
        if (result) {
          dispatch(toggleShowAlert(true, SUCCESS_ALERT, message));
          if (!clientObj.id) {
            const value = { id: result.data };
            dispatch({ type: SET_POST_FIELD_CHANGE, value });
          }
        }
        dispatch(setIsSaving(false));

        if (clientObj.post_type === ANNOUNCEMENT) {
          window.location.href = "/#/posts";
        } else if (
          clientObj.post_type === TERMS ||
          clientObj.post_type === PRIVACY_POLICY ||
          clientObj.post_type === FAQS
        ) {
          window.location.reload();
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const resetPost = () => {
  return (dispatch) => {
    dispatch({ type: RESET_POST });
  };
};

export const filterPosts = (filter) => {
  return (dispatch) => {
    dispatch({ type: POST_FILTER, filter });
  };
};

export const clearPosts = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_POSTS });
  };
};

export const searchPosts = (searchKeyword, searchCallback = null) => {
  return (dispatch) => {
    dispatch(clearPosts());

    searchCallback({
      search: searchKeyword,
    });
  };
};
